module.exports = __webpack_public_path__ + "static/media/back_arrow.f7bc94d0.svg";